import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HomeLayoutComponent } from './home-layout.component';
import { RouterModule } from '@angular/router';
import { HeaderModule } from '../../common/components/header/header.module';
import { FooterModule } from '../../common/components/footer/footer.module';
import { HeaderTopModule } from '../../common/components/header-top/header-top.module';
@NgModule({
  declarations: [
    HomeLayoutComponent
  ],
  imports: [
    CommonModule,
    RouterModule,
    HeaderTopModule,
    HeaderModule,
    FooterModule
  ],
  exports: [
    HomeLayoutComponent
  ]
})
export class HomeLayoutModule { }
